import React from "react";
import Layout from "./components/Layout";
import "./index.css";
import ContactForm from "./components/contactForm";
import ProjectsSection from "./components/ProjectsSection";

function App() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <Layout>
      <div className="container mx-auto px-4 py-16">
        {/* Hero Section */}
        <section
          id="hero"
          className="min-h-screen flex items-center justify-center"
        >
          <div className="text-center">
            <h1 className="text-4xl md:text-6xl font-bold text-gray-900 dark:text-white mb-6">
              Welcome to My Portfolio
            </h1>
            <p className="text-xl text-gray-600 dark:text-gray-300 mb-8">
              I'm a fullstack developer creating quality code and experiences
            </p>
            <button
              onClick={() => scrollToSection("projects")}
              className="bg-primary text-white px-8 py-3 rounded-lg hover:bg-blue-700 transition-colors duration-200"
            >
              View My Work
            </button>
          </div>
        </section>

        {/* About Section */}
        <section
          id="about"
          className="min-h-screen flex items-center justify-center bg-white dark:bg-gray-800 -mx-4 px-4"
        >
          <div className="max-w-4xl mx-auto text-center">
            {/* Circular Image */}
            <div className="mb-8 flex justify-center">
              <img
                src="/profile.png"
                alt="Christer Bengtsson"
                className="w-48 h-48 rounded-full object-cover shadow-lg border-4 border-primary"
              />
            </div>

            <h2 className="text-3xl md:text-5xl font-bold text-gray-900 dark:text-white mb-6">
              About Me
            </h2>
            <div className="text-lg text-gray-600 dark:text-gray-300 space-y-4 max-w-2xl mx-auto">
              <p>
                After several years in marketing and communications, I decided
                it was time for a change. I've always been drawn to technology —
                I've built more WordPress sites than I can count — and several
                of my previous roles naturally gravitated toward the technical
                side of things.
              </p>
              <p>
                Software development felt like the logical next step. I've just
                graduated from a two-year higher vocational education program
                focused on Java and Spring Boot, building full-stack
                applications with React and TypeScript on the frontend. This
                portfolio itself is a React app styled with Tailwind CSS, backed
                by a Spring Boot REST API with PostgreSQL — deployed and
                connected to a live database.
              </p>
              <p>
                I recently wrapped up a six-month internship — part of my
                education program — working with C# and Entity Framework, where
                I built a semantic search feature powered by Azure OpenAI. I've
                also built Tomewise, an open-source application written in C#
                and EF, publicly available at{" "}
                <a
                  href="https://tomewise.se"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary hover:text-blue-700 underline"
                >
                  tomewise.se
                </a>
                . Looking forward to bringing this full-stack skill set —
                spanning Java/Spring Boot and C#/.NET — to a development team.
              </p>
            </div>
          </div>
        </section>

        {/* Projects Section */}
        <section id="projects">
          <ProjectsSection />
        </section>

        {/* Contact Section */}
        <section id="contact" className="bg-white dark:bg-gray-800 py-16">
          <div className="container mx-auto px-4">
            <ContactForm />
          </div>
        </section>
      </div>
    </Layout>
  );
}

export default App;
